import React from 'react'
import { StyleSheet, View } from 'react-native'
import {
  Title,
  Space
} from '@sart/components'
import { useContent } from '@sart/content'
import { GuruSerenity } from '@sart/icons'
import { colors  } from '@sart/styles'

export default function CheckoutLoading(props) {
  const content = useContent();

  return (
    <View style={styles.container}>
      <Space height={24} />
      <GuruSerenity width={220} height={181}/>
      <Space height={2 * 24} />

      <Title style={styles.title}>
        {content.common.loading}
      </Title>
      
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24
  },
  title: {
    color: colors.srGreen,
    fontSize: 24
  },
})
